<script>
  import FormGroup from "./FormGroup.svelte";
  import SvelteTooltip from "svelte-tooltip";
  import { onMount } from "svelte";
  import { getNotificationsContext } from "svelte-notifications";
  import { Tabs, Tab, TabList, TabPanel } from "svelte-tabs";
  import ComplaintFormService from "./../complaintFormService.js";
  import moment from "moment";
  import "moment/locale/es";
  
  const { addNotification } = getNotificationsContext();
  let files = [];
  let id = "";
  let password = "";
  let errors = null;
  let error = null;
  let message = "";
  let messageError = null;
  let messages = null;
  let answers = null;
  let button_send_chat_label = 'Enviar Mensaje'
  let newFiles = [];
  export let data = null;
  export let handleShowSate = null;

  onMount(async () => {
    var locale = window.navigator.userLanguage || window.navigator.language;
    moment.locale(locale);

    if (data) {
      answers = data.complaint_form_answer;
      messages = data.messages;
    }
  });

  /* Handle input file changes (Only when files are selected by user) */
  function handleChange(e) {
    files = Array.from(e.target.files);
    renderPrevieImage(files);
  }

  /* Delete file */
  function deleteFile(file) {
    const fileIndex = files.findIndex(
      a => a.name == file.name && a.size == file.size
    );

    files.splice(fileIndex, 1);

    const dt = new DataTransfer();

    for (let file of files) {
      dt.items.add(file);
    }

    let input = document.getElementById("multifile");

    input.files = dt.files;

    files = Array.from(dt.files);

    renderPrevieImage(files);
  }

  /* Render preview image */
  async function renderPrevieImage(files) {
    let filesArray = Array.from(files);

    for (let i = 0; i < filesArray.length; i++) {
      let f = await getBase64(filesArray[i]);
      const parts = filesArray[i].name.split(".");
      newFiles.push({
        base64: f,
        name: parts[0],
        extension: parts[1]
      });
    }

    error = null;

    modifyData({
      //question_uuid: question.uuid,
      files: newFiles
    });

    console.log(newFiles);

    files.forEach((file, i) => {
      const image = /\.(jpe?g|png|gif)$/i.test(file.name);
      var reader = new FileReader();

      reader.onload = function() {
        var output = document.getElementById(`image_${file.name}`);
        output.src = image ? reader.result : "images/no-preview.jpg";
      };

      reader.readAsDataURL(file);
    });
  }

  function getBase64(file) {
    return new Promise(function(resolve) {
      var reader = new FileReader();
      reader.onloadend = function() {
        resolve(reader.result);
      };
      reader.readAsDataURL(file);
    });
  }

  function addInitialData() {}

  function modifyData() {}

  async function checkComplaint() {
    if (data) {
      const response = await ComplaintFormService.getComplaintAnswer(
        answers.uuid
      );

      if (response.success) {
        data = response.body;
        answers = response.body.complaint_form_answer;
        messages = response.body.messages;
      }
    } else {
      const response = await ComplaintFormService.checkComplaint({
        id: id,
        password: password
      });

      if (!response.success) {
        if (response.body.code === 5) {
          AuthService.logout();
        } else if (response.body.code === 4) {
          errors = response.body;
        } else if (response.body.code === 8) {
          id = "";
          password = "";
          errors = null;
          addNotification({
            id: new Date().getTime(),
            text: "Atención",
            description:
              "No se han encontrado resultados con los datos ingresados",
            removeAfter: 4000,
            position: "bottom-right",
            type: "danger"
          });
        }
      } else {
        answers = response.body.complaint_form_answer;
        messages = response.body.messages;
      }
    }
  }

  async function sendMessage() {

    button_send_chat_label = 'Enviando... Favor espere!'

    console.log(files)

    const createMessage = await ComplaintFormService.createMessage(
      answers.uuid,
      message,
      newFiles
    );

    if (!createMessage.success) {

      console.log(createMessage.body)

      messageError = createMessage.body;
    } else {
      message = "";
      checkComplaint();
    }

    button_send_chat_label = 'Enviar Mensaje'

  }
</script>

<section id="denuncia-estado" class="section mx-5">
  <div class="container">
    {#if !answers}
      <h2 class="text-center font-weight-600 text-uppercase mb-5">
        Consulte el estado de su caso (denuncia / asistencia legal)
      </h2>
      <form id="form-estado-denuncia">
        <div class="p-4 bg-white">

          <div class="row">
            <div class="col-md-6 col-lg-6">
              <h3 class="text-3 mb-3">Número de caso</h3>
              <div class="form-group">
                <input
                  type="text"
                  name="id"
                  class={`form-control inputs ${errors && errors.details.id ? 'is-invalid' : ''}`}
                  bind:value={id} />
                <div class="invalid-feedback">
                  {errors && errors.details.id}
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <h3 class="text-3 mb-3">Contraseña</h3>
              <div class="form-group">
                <input
                  type="password"
                  name="password"
                  class={`form-control inputs ${errors && errors.details.password ? 'is-invalid' : ''}`}
                  bind:value={password} />
                <div class="invalid-feedback">
                  {errors && errors.details.password}
                </div>
              </div>
            </div>
            <div class="col-md-12 col-lg-12">
              <p class="text-center mt-4 mb-0">
                <button
                  id="submit-btn"
                  class="btn btn-primary btn-block rounded-0 shadow-none
                  justify-content-center"
                  on:click={checkComplaint}
                  type="button">
                  Consulta
                </button>
              </p>
            </div>
          </div>

        </div>
      </form>
    {:else}
      <div class="row">
        <div class="col-12 bg-white pt-2">
          <div style="font-size: medium;">
            <Tabs>
              <TabList>
                <Tab>Resumen</Tab>
                <Tab>Chat</Tab>
              </TabList>

              <TabPanel>
                <div class="mt-4">
                  <table class="table">
                    <thead class="text-white" style="background-color:#4843d2;">
                      <tr>
                        <th scope="col">Empresa</th>
                        <th scope="col">Tipo</th>
                        <th scope="col">Fecha denuncia</th>
                        <th scope="col">Estado</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{answers.client.company}</td>
                        <td>
                          {#if answers.type === 'free_assistance'}
                            Asistencia Legal Gratuita
                          {:else if answers.type === 'complaint'}
                            Denuncia
                          {:else}
                            ERROR TIPO
                          {/if}
                        </td>
                        <td>
                          {moment(answers.created_dt).format('DD/MM/YYYY HH:mm')}
                        </td>
                        <td>
                          {#if answers.state === 'started'}
                            Iniciado
                          {:else if answers.state === 'in_progress'}
                            En progreso
                          {:else if answers.state === 'finished'}
                            Finalizado
                          {:else}Estado no conocido{/if}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {#each answers.groups as group, i}
                  <FormGroup
                    {group}
                    {addInitialData}
                    {modifyData}
                    errors={null} />
                {/each}

              </TabPanel>

              <TabPanel>
                <div class="row">
                  <div class="col-12">
                    <div class="card my-3">
                      <div class="card-body">
                        {#each messages as message}
                          <div class="card ml-2 my-2">
                            <div class="bg-light clearfix">
                              <div class="d-flex card-header p-1 {message.user ? 'bg-info text-white' : 'bg-secondary text-white'}">
                                <div 
                                  class="mr-auto p-2 font-weight-bold"
                                >
                                  {message.user ? `${message.user.first_name} ${message.user.last_name}` : 'Usuario anónimo'}
                                </div>
                                <div class="ml-auto p-2">
                                  Fecha: {message.created_dt}
                                </div>
                              </div>
                              <div class="card-body text-2 px-3 py-2">
                                {@html message.message}
                                <span class="float-right">{#if (message.assets.length > 0)}<a href="{message.assets[0].url}" target="_blank"><i class="fa fa-paperclip"></i></a>{/if}</span>
                              </div>
                            </div>
                          </div>
                        {:else}
                          <div class="alert alert-warning mb-0 text-2">
                            Aún no hay mensajes
                          </div>
                        {/each}
                      </div>
                      <div class="card-footer">
                        <h4 class="text-3 ml-2 mt-2">Escriba su mensaje a continuación:</h4>
                        <div class="form-group">
                          <textarea
                            name="name"
                            rows="6"
                            class={`text-2 form-control inputs ${messageError ? 'is-invalid' : ''}`}
                            bind:value={message} />

                          {#if messageError}
                            {#if messageError.details.message}
                            <div class="invalid-feedback">
                              {messageError.details.message}
                            </div>
                            {/if}
                          {/if}

                          <div class="form-group mb-1 mt-3">
                            <input
                              id="multifile"
                              accept='jpg,png,gif,xlsx'
                              name="name"
                              type="file"
                              multiple={true}
                              on:change={e => handleChange(e)}
                              class={`form-control inputs ${messageError ? 'is-invalid' : ''}`} />


                            {#if messageError}
                              {#if messageError.details.files}
                              <div class="invalid-feedback">
                                {messageError.details.files}
                              </div>
                              {/if}
                            {/if}

                            <div class="row mt-4">
                              {#each files as file, i (i)}
                                <div class="col-md-2 col-lg-2 mx-2">
                                  <div class="text-center">
                                    <div class="tooltip-color">
                                      <SvelteTooltip
                                        tip={`Nombre: ${file.name} - Tamaño: ${(file.size / (1024 * 1024)).toFixed(2)} MB`}
                                        color="#4843d2"
                                        top>
                                        <img
                                          src=""
                                          id={`image_${file.name}`}
                                          alt={file.name}
                                          class="img-preview rounded" />
                                      </SvelteTooltip>
                                    </div>
                                    <span class="remove" on:click={() => deleteFile(file)}>
                                      Eliminar
                                    </span>
                                  </div>
                                </div>
                              {/each}
                            </div>
                          </div>





                          <p class="text-muted text-1 ml-2 mt-2"><strong>Nota:</strong> este mensaje llegará al abogado asignado a esta denuncia.</p>

                        </div>
                        <div class="d-flex">
                          <button
                            id="submit-btn"
                            class="btn btn-primary rounded-0 shadow-none ml-auto"
                            on:click={sendMessage}
                            type="button">
                            {button_send_chat_label}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>
    {/if}
  </div>
</section>
